import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productBrand, productEdition, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-line bg-navy-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-180" data-mp="3bhbu9hm7k3fw">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-181" data-mp="36jk4ou91ctev">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-navy-950 px-3 py-1.5 text-sm font-medium text-white" data-id="element-182" data-mp="31kz0kjqnxpl5">
          <AwardIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-183" data-mp="2wrw7ecpssi5h" /> The Most Complete Telecommunications & Fiber Optic Networks Professional System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-184" data-mp="2nuvm4ey0z069">
          {productBrand} — <span className="text-gold" data-id="element-185" data-mp="2it68crjf48eh">{productEdition}</span>
        </SectionHeading>
        <p className="mt-4 font-medium text-silver" data-id="element-186" data-mp="2dumn6tcnf0n6">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-xl border border-line bg-navy-950 p-6 text-left text-lg font-medium leading-relaxed text-white shadow-lg shadow-black/30" data-id="element-187" data-mp="13xn45n5w99tn">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-fiber" aria-hidden="true" data-id="element-188" data-mp="u2lemq7pi5qj" />
          A complete, vendor-neutral technical reference to understand how telecommunications networks work: how light
          travels through fiber from the splice tray to the patch panel, how structured cabling, FTTH and PON connect
          every user, how radio links and cell sites extend the network, and how professionals operate and maintain it
          safely.
        </p>
      </div>
    </section>;
}